import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, List, Card, Button, Radio, Checkbox, Select,
  Carousel, Typography,
} from 'antd';
import _ from 'lodash'
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import {API_HOST}  from '../../configs/env';
import whttp    from '../../libs/whttp';
import WJSON from 'libs/wjson';
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL')

// 前端頁面
export default class WidgetWeather extends Component {
  state = {
    query:{
      a: null,
      t: null,
      id:null
    },
    cityid : null,

  }
  componentDidMount() {
    const query = AppHelper.getHashParamaters()
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {a:null,t:null,id:null}
    
    if (!query.a && cacheQuery.a) {
      query.a = cacheQuery.a
    }
    //console.log('componentDidMount', query, cacheQuery)
    this.setState({ query })
    this.loadData(query)
  }
  
  loadData = (query={}) => { 
    this.setState({ isFetchData: true })
    const cityid = query.a
    whttp.sharedGet(API_HOST + `/api/account/getWeather/${cityid||''}`, {
    },
    (state, res) => {
      this.setState({ isFetchData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      //console.log(code, reason, data, res)

      if (state === false || code !== 200) {
        console.error(reason)
        return
      }
      
      this.setState({ weatherInfo: data.weather })
    })
  }

  render() { 
    const weatherInfo = _.get(this, 'state.weatherInfo')
    let className = 'icon-weather_8-1'
    let wx = _.get(weatherInfo, 'Wx','')
    
    if (wx.includes('雲'))  {className = 'icon-weather_8-2'}
    if (wx.includes('雨'))  {className ='icon-weather_8-6'}
    if (wx.includes('雪'))  {className ='icon-weather_8-7'}
    if (wx.includes('風大')) {className ='icon-weather_8-8'}
    if (wx.includes('晴時多雲')) {className = 'icon-weather_8-3'}
    if (wx.includes('多雲時陰短暫陣雨')) {className ='icon-weather_8-4'}
    if (wx.includes('雷雨') || wx.includes('雷陣雨')) {className ='icon-weather_8-5'}
    this.setState()
    return (
      <Fragment>
        <div class="weather"><span class="iconBox"> <i className={className}></i></span>{_.get(weatherInfo,'MaxT','--')}°C</div>
     
      </Fragment>
      
    )
  }
}

// 編輯器
export class WidgetWeatherEditor extends Component {
  render() {
    return (
      <div className="vu-blocks-editor">
        <div class="components-placeholder__label">
          <span class="block-editor-block-icon"><div class="dashicons dashicons-cloud" /></span>
          天氣元件
        </div>
      </div>
    )
  }
}  


// WEBPACK FOOTER //
// ./src/blocks/widget/widget-weather.js